import { createFileRoute } from '@tanstack/react-router';

import GlobalToplist from '~/toplist/GlobalToplist';

export const Route = createFileRoute('/_protected/toplist')({
  component: GlobalToplist,
});
